module.exports = __webpack_public_path__ + "img/films.50b550be.jpg";